import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Card, Col, Container, Row, Button, Stack } from 'react-bootstrap';
import { Formik, Form, FormikHelpers } from 'formik';
import { useTranslation } from 'react-i18next';
import { isNull, isUndefined, startCase } from 'lodash';

import { FormGroupCheck, FormGroupControl, Loading, LoadingError } from '@components/Base';

import { useCorporateHealthQuoteFetch } from '../hook';
import { corporateHealthQuotePayByCash, CorporateHealthQuotePayByCashPayload } from '../action';
import { RightCol } from '../right-col';
import { useInitialValues, useValidationSchema } from './hook';
import { FormValues } from './type';

const GROUP_PROPS = { className: 'mb-3' };

const CorporateHealthQuoteBuyPayByCashPage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const corporateHealthQuote = useCorporateHealthQuoteFetch();
  const initialValues = useInitialValues();
  const validationSchema = useValidationSchema();

  if (isUndefined(corporateHealthQuote)) return <Loading />;
  if (isNull(corporateHealthQuote)) return <LoadingError />;
  if (!initialValues) return null;

  const { orderNumber } = corporateHealthQuote;

  const handleSubmit = (values: FormValues, { setSubmitting }: FormikHelpers<FormValues>) => {
    const payload: CorporateHealthQuotePayByCashPayload = { orderNumber, ...values };
    dispatch(corporateHealthQuotePayByCash(payload));
    setSubmitting(false);
  };

  return (
    <Container className="my-3">
      <Row className="gy-5">
        <Col lg={8}>
          <Formik initialValues={initialValues} onSubmit={handleSubmit} validationSchema={validationSchema}>
            {() => (
              <Form>
                <Card>
                  <Card.Body>
                    <FormGroupCheck name="agree" groupProps={GROUP_PROPS} label="Mark as paid" />
                    <FormGroupControl name="proof" type="file" label={t('proof')} groupProps={GROUP_PROPS} />
                  </Card.Body>

                  <Card.Footer className="bg-white border-0 mx-auto my-4">
                    <Stack direction="horizontal" gap={3}>
                      <Button onClick={() => navigate(-1)} variant="outline-primary" size="lg">
                        {t('common:cancel')}
                      </Button>

                      <Button type="submit" variant="primary" size="lg">
                        {startCase(t('common:payByCash'))}
                      </Button>
                    </Stack>
                  </Card.Footer>
                </Card>
              </Form>
            )}
          </Formik>
        </Col>

        <RightCol corporateHealthQuote={corporateHealthQuote} />
      </Row>
    </Container>
  );
};

export { CorporateHealthQuoteBuyPayByCashPage };
